import { Divider, Paper, Stack } from '@mui/material'
import { Fragment } from 'react/jsx-runtime'
import { SPACING } from '@common/theme/spacing'
import ReassignExamDetails from './ReassignExamDetails'
import { ContainerParam } from '@features/subject/subject.types'

export default function ReassignExamDetailsList({
  container,
  isExamSelected,
  onExamSelection,
}: {
  container: ContainerParam
  isExamSelected: (examId: string) => boolean
  onExamSelection?: (examId: string, isSelected: boolean) => void
}) {
  return (
    <Paper
      sx={{
        borderRadius: SPACING.borderRadiusXxl,
        bgcolor: 'paper.main',
      }}
    >
      <Stack spacing={SPACING.examDetailsListSpacing}>
        {container.examMetadata?.map((exam, index) => {
          return (
            <Fragment key={index}>
              {index !== 0 && <Divider />}
              <ReassignExamDetails
                exam={exam}
                container={container}
                isSelected={exam.exam_metadata_id ? isExamSelected(exam.exam_metadata_id) : false}
                onSelectionChange={onExamSelection}
              />
            </Fragment>
          )
        })}
      </Stack>
    </Paper>
  )
}
